import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("Attempting login with:", username);

      const API_BASE_URL =
        process.env.REACT_APP_API_ENTRYPOINT || "http://localhost:8085/kzc";
      console.log("API URL:", `${API_BASE_URL}/api/auth/login`);

      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userName: username, password }),
      });

      console.log("Response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful, data:", data);

        const result = await login(username, password);
        console.log("Context login result:", result);

        if (result.success) {
          console.log("Redirecting based on role:", data.role);

          if (data.role === "ADMIN" || data.role === "EDITOR" || data.role === "VIEWER") {
            // navigate("/auth/admin");
            navigate("/admin");

          } else if (data.role === "USER") {
            navigate("/home");
          } else {
            navigate("/");
          }
        } else {
          setError(result.error || "Login failed");
        }
      } else {
        const errorText = await response.text();
        console.log("Error response:", errorText);

        try {
          const errorData = JSON.parse(errorText);
          setError(errorData.error || "Invalid credentials");
        } catch {
          setError(errorText || "Invalid credentials");
        }
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center"
      style={{
        background:"#1a3625"
          // "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5">
            <div className="card border-0 shadow-lg overflow-hidden">
              <div className="row g-0 p-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  alt="Admin"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    display: "block",
                    margin: "0 auto 20px auto",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  }}
                />

                <div className="text-center mb-4">
                  <h3 className="fw-bold text-primary">Login</h3>
                  <p className="text-muted">Sign in to get started</p>
                </div>

                {/* <div
                  style={{
                    marginBottom: "20px",
                    padding: "10px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                >
                  <strong>Test Credentials:</strong>
                  <br />
                  • Admin: username: "01823423434", password: "admin123"
                  <br />• User: username: "01723423424", password: "user123"
                </div> */}

                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 text-start">
                    <label>Username</label>
                    <input
                      type="text"
                      className="form-control"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      disabled={loading}
                      placeholder="Enter username"
                    />
                  </div>

                  <div className="form-group mb-3 text-start">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                      placeholder="Enter password"
                    />
                  </div>

                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn btn-primary w-100 mb-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Logging in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                </form>
              </div>
            </div>{" "}
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default LoginPage;
